<div class="form" [formGroup]="form">
  <nx-edit-select-input
    [showLabel]="true"
    [panelWidhtFull]="true"
    formControlName="selected"
    [filter]="true"
    [options]="options"
    [onFilter]="onFilter"
    [placeholder]="placeholder()"
    [showClear]="true"
    [label]="label()">
  </nx-edit-select-input>

</div>
